import { getDetailUrl } from "./get-detail-url";
import { getJsonLdData } from "./get-json-ld-data";
import {
  isVideoLegacySeason,
  isVideoSeason,
  isVideoSpotLiveSeason,
  isVideoStageSeason,
} from "~/components/blocks/product/type-guard";
import type { Queries } from "~/const/hrefs";
import { OGP_IMAGE } from "~/const/meta";
import type { G_GetVideoQuery } from "~/lib/graphql";

let categoryName = "";
let ogpImage = OGP_IMAGE;

type GetOgpDataArgs = {
  videoData: G_GetVideoQuery["video"];
  spot?: Queries["spot"];
};

/** 作品詳細の`headタグ`の機能要件を満たすために必要な関数 */
export const getDetailHeadData = ({ videoData, spot }: GetOgpDataArgs) => {
  const { titleName, categories } = videoData;

  if (categories !== undefined && categories.length > 0) {
    const animeCategoryName = categories.find((item) => item.name === "アニメ")?.name;

    if (animeCategoryName !== undefined) {
      categoryName = animeCategoryName;
    } else {
      categoryName = categories[0].name;
    }
  }

  const { detailBreadcrumbJsonLdData, detailTvJsonLdData } = getJsonLdData({ videoData });

  const ogpTitle =
    categoryName !== ""
      ? `${titleName}（${categoryName}）| DMM TVで30日間無料体験`
      : `${titleName} | DMM TVで30日間無料体験`;

  const ogpDescription = `＜30日間無料体験＞「${titleName}」が楽しめる！アニメ・エンタメ動画なら作品数が最大級のDMM TV`;

  const { ogpDetailUrl, canonicalDetailUrl, aiadDetailBackUrl } = getDetailUrl({
    spot,
    videoData,
  });

  // 優先順位 : ロゴなしキービジュアル < ロゴありキービジュアル
  if (isVideoSeason(videoData) || isVideoStageSeason(videoData) || isVideoSpotLiveSeason(videoData)) {
    if (videoData.keyVisualWithoutLogoImage) {
      ogpImage = {
        url: videoData.keyVisualWithoutLogoImage,
        width: 1920,
        height: 1080,
      };
    }

    if (videoData.keyVisualImage) {
      ogpImage = {
        url: videoData.keyVisualImage,
        width: 1920,
        height: 1080,
      };
    }
  }

  if (isVideoLegacySeason(videoData)) {
    if (videoData.packageImage) {
      ogpImage = {
        url: videoData.packageImage,
        width: 1536,
        height: 2184,
      };
    }
  }

  return {
    ogpTitle,
    ogpDescription,
    ogpDetailUrl,
    ogpImage,
    canonicalDetailUrl,
    aiadDetailBackUrl,
    detailTvJsonLdData,
    detailBreadcrumbJsonLdData,
  };
};
